import React from "react";
import Pagetitle from "./component/Pagetitle";
import { useForm } from "react-hook-form";
import axios from "axios";

const Contact = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  const { register, handleSubmit, formState: { errors, }, reset, setValue } = useForm({
    defaultValues: {
      name: "",
      email: "",
      message: ""
    },
  });

  const handleSend = async (data) => {
    try {
      //console.log(data);
      const response = await axios.post(`${apiBaseUrl}/Contact`, data);
      if (response.status != 201) {
        alert('There was problem submitting your request. Please try again after some time!');
        return;
      }
      reset({
        name: "",
        email: "",
        message: ""
      });
      alert('Your request have been submitted successfully. We will get in touch soon!');
    } catch (error) {
      console.error("There was an error saving data!", error);
    }
  };

  return (
    <>
      <Pagetitle title="Contact Us" />
      <section className="flat-spacing-9">
        <div className="container">
          <div className="tf-grid-layout gap-0 lg-col-2">
            <div className="w-100">
              {/* <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d317859.6089702069!2d-0.075949!3d51.508112!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760349331f38dd%3A0xa8bf49dde1d56467!2sTower%20of%20London!5e0!3m2!1sen!2sus!4v1719221598456!5m2!1sen!2sus" width="100%" height="894" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe> */}
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15066.706121741985!2d73.00354720078424!3d19.252924200000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7bda9d08b328d%3A0x1717656f0f34053f!2sShree%20Arihant%20Complex!5e0!3m2!1sen!2sin!4v1744555782724!5m2!1sen!2sin" width="100%" height="894" style={{ border: 0 }}allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div className="tf-content-left has-mt">
              <div className="sticky-top">
                <h5 className="mb_20">Visit Our Store</h5>
                <div className="mb_20">
                  <p className="mb_15"><strong>Address</strong></p>
                  <p>Barkati Creation, Shree Arihant Complex,</p>
                  <p>C5, 2nd floor, Gala no. 4,</p>  
                  <p>Reti Bunder Road, Near Shilpa hotel Kalher Pipe Line,</p> 
                  <p>Kalher, Bhiwandi</p>
                </div>
                <div className="mb_20">
                  <p className="mb_15"><strong>Phone</strong></p>
                  <p>(+91) 808-037-7402</p>
                </div>
                <div className="mb_20">
                  <p className="mb_15"><strong>Email</strong></p>
                  <p>info@geniusbaby.com</p>
                </div>
                <div className="mb_36">
                  <p className="mb_15"><strong>Open Time</strong></p>
                  <p className="mb_15">Our store has re-opened for shopping, </p>
                  <p>exchange Every day 11am to 7pm</p>
                </div>
                <div>
                  <ul className="tf-social-icon d-flex gap-20 style-default">
                    <li><a href="#" className="box-icon link round social-facebook border-line-black"><i className="icon fs-14 icon-fb"></i></a></li>
                    <li><a href="#" className="box-icon link round social-twiter border-line-black"><i className="icon fs-12 icon-Icon-x"></i></a></li>
                    <li><a href="#" className="box-icon link round social-instagram border-line-black"><i className="icon fs-14 icon-instagram"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg_grey-7 flat-spacing-9">
        <div className="container">
          <div className="flat-title">
            <span className="title">Get in Touch</span>
            <p className="sub-title text_black-2">If you’ve got great products your making or looking to work with us then drop us a line.</p>
          </div>
          <div>
            <form className="mw-705 mx-auto text-center form-contact" id="contactform" onSubmit={handleSubmit(handleSend)}>
              <div className="d-flex gap-15 mb_15">
                <fieldset className="w-100">
                  <input type="text" name="name" id="name" placeholder="Name *" {...register("name", { required: "Name is required." })} />
                  <span className='text-xs text-danger'>{errors.name?.message}</span>
                </fieldset>
                <fieldset className="w-100">
                  <input type="text" name="email" id="email" placeholder="Email *" {...register("email", { required: "Email is required.", pattern: { value: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: "Please enter valid email id." } })} />
                  <span className='text-xs text-danger'>{errors.email?.message}</span>
                </fieldset>
              </div>
              <div className="mb_15">
                <textarea placeholder="Message *" name="message" id="message" cols="30" rows="10" {...register("message", { required: "Message is required." })}></textarea>
                <span className='text-xs text-danger'>{errors.message?.message}</span>
              </div>
              <div className="send-wrap">
                <button type="submit" className="tf-btn radius-3 btn-fill animate-hover-btn justify-content-center">Send</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
